module.exports = __webpack_public_path__ + "static/me-3290446337cfa5e8aa856b6135bec162.jpg";